<template>
  <div class="quiz_content">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'QuizContent'
}
</script>

<style scoped>
  .quiz_content {
    background: #fff;
    border-radius: 48px 0 48px 0;
    margin: 0 45px 50px;
    min-width: 900px;
  }

  @media screen and (max-width: 767px) {
    .quiz_content {
      margin: 0 3% 50px;
      min-width: auto;
    }
  }

</style>
